<template>
  <div class="consultant">
    <!-- 对公转账入口：仅在支持该权益类型时显示 -->
    <Button
      v-if="canCorporateTransfer(rightType)"
      class="consultant__transfer-btn"
      variant="border-back"
      @click="handleTransferClick"
    >
      {{ $t('dui-gong-zhuan-zhang') }}
    </Button>
    <!-- 客服入口 -->
    <Button class="consultant__service-btn" block variant="border-back" @click="openCustomer">
      {{ $t('lian-xi-ke-fu') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import { ModalFactory } from '@rendora/common/features/modals/factory';
// 转账/客服入口：若存在未支付的转账订单则拦截，否则弹出转账下单弹窗
import { getOrderList } from '@rendora/common/entities/order';
import { getI18nService } from '@rendora/common/services/i18n';
import { useUserStore } from '@rendora/common/store/user';
import { ORDER_STATUS, ORDER_TYPE, PAY_TYPE, type IRightsType } from '@rendora/common/types/enums';
import { openCustomerService } from '@rendora/common/utils/kefu';
import { Button } from '@rendora/design/components/button/index';
import { useTransferIntercept } from './transfer-intercept/index';

const i18nService = getI18nService();
const $t = i18nService.t;

const props = defineProps<{
  rightType: IRightsType;
  orderType: ORDER_TYPE;
  transferDisabled: boolean;
}>();

const emits = defineEmits(['transfer']);

const { canCorporateTransfer } = useUserStore();

// 打开在线客服
function openCustomer() {
  openCustomerService();
}

// 检查是否已有未支付的对公转账订单
const checkExistingTransferOrder = async () => {
  const res = await getOrderList({
    pay_type: PAY_TYPE.TRANSFER,
    status: ORDER_STATUS.UNPAID,
    order_type: props.orderType,
    many: 1,
  });
  const orderDetail = res?.results?.[0];
  if (orderDetail) {
    useTransferIntercept({
      order: orderDetail,
    });
  } else {
    ModalFactory.confirm({
      title: $t('dui-gong-zhuan-zhang'),
      content: $t('que-ren-xuan-ze-dui-gong-zhuan-zhang-de-fang-shi-jin-hang-fu-kuan-ma-0'),
      okText: $t('qu-zhi-fu'),
      cancelText: $t('qu-xiao'),
      onOk: () => {
        emits('transfer');
      },
    });
  }
};

// 触发对公转账流程
function handleTransferClick() {
  checkExistingTransferOrder();
}
</script>

<style lang="scss" scoped>
.consultant {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  &__transfer-btn {
    // 对公转账按钮样式
    min-height: 36px;
  }

  &__service-btn {
    // 联系客服按钮样式
    min-height: 36px;
  }
}
</style>
